var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
    'search-bar',
    {
      'opacity-bg': _vm.props.onTop
    }
  ],on:{"click":_vm.listeners['go-search']}},[_c('div',{staticClass:"input"},[_c('IconFont',{attrs:{"name":"sousuokuang"}}),_c('span',{staticClass:"hot-words"},[_vm._v("搜索冻品")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }